import { useColorMode } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';
import { buttonBoxColorStyle } from '../constants/HomeStyleConst';

export default function PhotoSearchLinkButton() {
  const navigate = useNavigate();
  const { colorMode } = useColorMode();

  return (
    <button
      type="button"
      className="w-[33px] h-[33px] p-[1.5px] flex items-center justify-center rounded-full bg-secondary-light dark:bg-secondary-dark cursor-pointer"
      onClick={() => navigate('/image-search')}
      style={buttonBoxColorStyle[colorMode].imageSearchButtonStyle}
    >
      <div className="w-full h-full bg-pure-white dark:bg-pure-black rounded-full flex items-center justify-center">
        <SpinningGradientIcon />
      </div>
    </button>
  );
}

const SpinningGradientIcon = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="20"
      height="19"
      viewBox="0 0 19 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-label="Spinning Gradient Icon"
      role="img"
      {...props}
    >
      <defs>
        <mask
          id="icon-mask"
          maskUnits="userSpaceOnUse"
          maskContentUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="19"
          height="19"
        >
          <path
            d="M6.42278 6.40631C8.0267 5.01673 10.4775 5.16418 11.8964 6.73492C13.1672 8.1425 13.1781 10.2141 12.0139 11.6298L13.1457 12.8845C13.4301 13.1998 13.4007 13.681 13.079 13.96C12.7572 14.2385 12.2648 14.2098 11.98 13.8947L10.8144 12.6024C9.26716 13.4111 7.30154 13.112 6.08845 11.7692C4.66977 10.198 4.81908 7.7962 6.42278 6.40631ZM10.7308 7.7451C9.88158 6.80514 8.4152 6.71676 7.45516 7.54816C6.49505 8.38003 6.40502 9.8174 7.25411 10.7579C8.10324 11.6981 9.5696 11.7862 10.5297 10.9549C11.4898 10.123 11.5798 8.68562 10.7308 7.7451Z"
            fill="#fff"
          />
          <path
            d="M16.198 13.7069C16.641 13.7071 17 14.0585 17 14.4925V16.5106C17 16.5682 16.9948 16.6248 16.9853 16.6799C16.9627 16.8107 16.9149 16.9332 16.8463 17.0417C16.7622 17.1746 16.6466 17.2879 16.5109 17.3703C16.4001 17.4375 16.2751 17.4843 16.1415 17.5064C16.0853 17.5157 16.0275 17.5208 15.9687 17.5208H13.9085C13.4655 17.5208 13.1068 17.1691 13.1065 16.7352C13.1065 16.3011 13.4653 15.9485 13.9085 15.9485H15.3283C15.3651 15.9483 15.3946 15.9193 15.3949 15.8833V14.4925C15.3949 14.0584 15.7548 13.7069 16.198 13.7069Z"
            fill="#fff"
          />
          <path
            d="M2.78108 6.29302C2.3381 6.29282 1.97913 5.94143 1.97913 5.50745L1.97913 3.48931C1.97913 3.43176 1.98433 3.37508 1.99381 3.32002C2.01638 3.18921 2.06417 3.06674 2.13274 2.95821C2.21685 2.82531 2.33252 2.71198 2.46821 2.6296C2.57901 2.56243 2.704 2.51561 2.83756 2.49351C2.89378 2.48422 2.95161 2.47913 3.01038 2.47913L5.07062 2.47913C5.51363 2.47913 5.87233 2.8308 5.87258 3.2647C5.87258 3.6988 5.51377 4.05138 5.07062 4.05138L3.65081 4.05138C3.61399 4.05165 3.58449 4.0806 3.58417 4.11666L3.58417 5.50745C3.58417 5.94156 3.22424 6.29302 2.78108 6.29302Z"
            fill="#fff"
          />
          <path
            d="M5.79302 16.7029C5.79282 17.1458 5.44143 17.5048 5.00745 17.5048H2.98931C2.93176 17.5048 2.87508 17.4996 2.82002 17.4901C2.68921 17.4676 2.56674 17.4198 2.45821 17.3512C2.32531 17.2671 2.21198 17.1514 2.1296 17.0157C2.06243 16.9049 2.01561 16.7799 1.99351 16.6464C1.98422 16.5902 1.97913 16.5323 1.97913 16.4736L1.97913 14.4133C1.97913 13.9703 2.3308 13.6116 2.7647 13.6114C3.1988 13.6114 3.55138 13.9702 3.55138 14.4133V15.8331C3.55165 15.8699 3.5806 15.8994 3.61666 15.8998H5.00745C5.44156 15.8998 5.79302 16.2597 5.79302 16.7029Z"
            fill="#fff"
          />
          <path
            d="M13.2069 3.28112C13.2071 2.83814 13.5585 2.47917 13.9925 2.47917L16.0106 2.47917C16.0682 2.47917 16.1248 2.48437 16.1799 2.49385C16.3107 2.51642 16.4332 2.56421 16.5417 2.63278C16.6746 2.71688 16.7879 2.83256 16.8703 2.96825C16.9375 3.07905 16.9843 3.20404 17.0064 3.3376C17.0157 3.39382 17.0208 3.45165 17.0208 3.51042V5.57066C17.0208 6.01367 16.6691 6.37237 16.2352 6.37261C15.8011 6.37261 15.4485 6.01381 15.4485 5.57066V4.15085C15.4483 4.11403 15.4193 4.08453 15.3833 4.08421L13.9925 4.08421C13.5584 4.08421 13.2069 3.72428 13.2069 3.28112Z"
            fill="#fff"
          />
        </mask>
      </defs>

      <g mask="url(#icon-mask)">
        <g>
          <foreignObject x="-2" y="-2" width="22" height="22">
            <div
              style={{
                width: '100%',
                height: '100%',
                // CSS conic-gradient 그대로 유지
                background:
                  'conic-gradient(from 90deg, rgba(229,179,0,1) 0deg, rgba(202,58,242,1) 102.6deg, rgba(3,211,255,1) 232.2deg, rgba(229,180,0,1) 360deg)'
              }}
            />
          </foreignObject>

          <animateTransform
            attributeName="transform"
            attributeType="XML"
            type="rotate"
            from="0 9.5 9.5"
            to="360 9.5 9.5"
            dur="2s"
            repeatCount="indefinite"
          />
        </g>
      </g>
    </svg>
  );
}

